import { motion } from 'framer-motion';

interface Props {
    color?: string;
}

export const TickIcon = ({ color = '#4BFF57' }: Props) => {
    return (
        <svg viewBox='0 0 100 100' style={{ width: '100%', height: '100%' }}>
            <motion.path
                d='M20 50 L45 75 L80 30'
                fill='none'
                stroke={color}
                strokeWidth='8'
                strokeLinecap='round'
                strokeLinejoin='round'
                initial={{ pathLength: 0 }}
                animate={{ pathLength: 1 }}
                transition={{ duration: 0.5, ease: 'easeOut', delay: 0.1 }}
            />
        </svg>
    );
};
